module.exports = __webpack_public_path__ + "media/packs/images/flags/LV-70a100b97a6d830ec6daf59a661dad70.png";